import React, { useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { KIND_META, STATUS_STYLE } from "@/lib/calendar";
import CalendarItemDialog from "@/components/calendar/CalendarItemDialog";
import OccurrenceSheet from "@/components/calendar/OccurrenceSheet";

export const OccChip = ({ o, onClick, size = "md", fill = false }) => {
  const st = STATUS_STYLE[o.status];
  const sm = size === "sm";
  return (
    <button type="button" onClick={(e) => { e.stopPropagation(); onClick(o); }}
      className={`w-full text-left flex items-center gap-1 rounded font-semibold truncate hover:brightness-95 active:scale-[0.98] transition-[filter,transform] ${sm ? "text-[9.5px] leading-[14px] px-1" : "text-[13px] px-2.5 py-1.5 rounded-md"} ${fill ? "h-full items-start" : ""}`}
      style={{ background: st.bg, color: st.fg, boxShadow: `inset 3px 0 0 ${KIND_META[o.kind]?.color}` }}
      data-testid={`cal-chip-${o.item_id}-${o.date}`} title={o.title}>
      {o.status === "done" && <CheckCircle2 className={sm ? "w-2.5 h-2.5 shrink-0" : "w-3.5 h-3.5 shrink-0"} />}
      {!sm && o.time && <span className="opacity-90 tabular-nums shrink-0">{o.time}</span>}
      <span className="truncate">{o.title}</span>
    </button>
  );
};

export const Legend = () => (
  <div className="flex flex-wrap gap-x-3 gap-y-1 text-[10.5px] text-slate-500" data-testid="cal-legend">
    {Object.entries(STATUS_STYLE).map(([k, s]) => (
      <span key={k} className="inline-flex items-center gap-1"><span className="w-2.5 h-2.5 rounded-sm" style={{ background: s.bg }} />{s.label}</span>
    ))}
    {Object.entries(KIND_META).map(([k, m]) => (
      <span key={k} className="inline-flex items-center gap-1"><span className="w-1 h-2.5 rounded-sm" style={{ background: m.color }} />{m.label}</span>
    ))}
  </div>
);

export const useCalendarDialogs = (reload) => {
  const [occ, setOcc] = useState(null);
  const [form, setForm] = useState({ open: false, editing: null, date: null });
  const dialogs = (
    <>
      <OccurrenceSheet occ={occ} onOpenChange={(v) => !v && setOcc(null)} onChanged={reload}
        onEdit={(o) => setForm({ open: true, editing: o, date: null })} />
      <CalendarItemDialog open={form.open} editing={form.editing} defaultDate={form.date} onSaved={reload}
        onOpenChange={(v) => setForm((p) => ({ ...p, open: v }))} />
    </>
  );
  return { openOcc: setOcc, openNew: (date) => setForm({ open: true, editing: null, date }), dialogs };
};
